import { TERMS_OF_SERVICE_DATA } from './termsOfService';
import { HOME_DATA } from './home';
import { CAROUSELS_DATA } from './carousels';
import { SETTINGS_DATA } from './settings';
import { PLAYER_MOVIE_SERIE_LIVE_DATA } from './playerMovieSerieLive';
import { MENU_DATA } from './menu';
import { LOGIN_DATA } from './login';
import { LOGIN_WEB_VALIDATION_CODE_DATA } from './loginWebValidationCode';
import { EPG_DATA } from './epg';
import { PDP_MOVIE_SERIE_LIVE_DATA } from './pdpMovieSerieLive';
import { SEARCH_DATA } from './search';
import { NETWORK_AND_COLLECTION_PAGE_DATA } from './networkAndCollectionPage';
import { LIVE_CATALOG_SPORTS_KIDS_PAGE_DATA } from './liveCatalogSportsKidsPage';
import { PROFILES_DATA } from './profiles';
import { MY_LIST_DATA } from './myList';
import { MY_PAGE_DATA } from './myPage';
import { PARENTAL_CONTROL_DATA } from './parentalControl';
import { ERRORS_DATA } from './errors';
import { MODAL_DATA } from './modal';

export const TAGS_HASH_AND_EVENTS = {
  carousels_data: CAROUSELS_DATA,
  epg_data: EPG_DATA,
  home_data: HOME_DATA,
  live_catalog_sports_kids_page_data: LIVE_CATALOG_SPORTS_KIDS_PAGE_DATA,
  login_data: LOGIN_DATA,
  login_web_validation_code_data: LOGIN_WEB_VALIDATION_CODE_DATA,
  menu_data: MENU_DATA,
  my_list_data: MY_LIST_DATA,
  my_page_data: MY_PAGE_DATA,
  pdp_movie_serie_live_data: PDP_MOVIE_SERIE_LIVE_DATA,
  network_and_collection_page_data: NETWORK_AND_COLLECTION_PAGE_DATA,
  player_movie_serie_live_data: PLAYER_MOVIE_SERIE_LIVE_DATA,
  search_data: SEARCH_DATA,
  settings_data: SETTINGS_DATA,
  profiles_data: PROFILES_DATA,
  parental_control_data: PARENTAL_CONTROL_DATA,
  errors_data: ERRORS_DATA,
  modal_data: MODAL_DATA,
  terms_of_service_data: TERMS_OF_SERVICE_DATA,
};
